import React, { useEffect, useState, useRef } from 'react';
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  Button,
  TextField,
  IconButton,
  Autocomplete,
  Paper,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { API, graphqlOperation } from 'aws-amplify';
import { createPartyAddressEntity, getCodeTranslation, getPartyAddressEntity } from '../../../graphql';
import { LocationFetch } from '../../../library/LocationFetch';
import useSaveModalShortcut from '../Components/useSaveModalShortcut';
import { showSuccessSnackbar } from '../../../components/snackBar/snakbar';
import { useSelector } from 'react-redux';
import { useStateList } from '../Components/HandleInvoiceStateProvider';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  outline: 'none',
  width:{xs:"90%", sm:"fit-content"}
};
const Countries = [{ option: 'India', value: 'IndiaState' }];
const EditBillingAddressModal = ({
  open,
  setOpen,
  partyID,
  setCountryArr,
  registrationType,
  addressType,
  setBillingAddressDetails,
  data,
  setData,
  invoiceEntry,
  Type,
  stateArr,
  tempbillingAddressDetails,
  setTempBillingAddressDetails,
  setStateArr,
  setDistrictArr,
  countryArr,
  districtArr,
  getStates,
  getDistricts,
  cityArr,
  setCityArr,
  partyType,
}) => {
  const{eImp ,eWayImp}=useStateList();
  const userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  const [editFlag, setEditFlag] = useState(false);
  const [openState, setOpenState] = useState(false);
  const [checkPermanent, setCheckPermanent] = useState(false);
  const [isChanges, setIsChanged] = useState(false);
  const [state, setState] = useState({
    billingAddress: '',
    states: { label: '', value: '', code: '' },
    district: { label: '', value: '' },
    country: { label: 'India', value: 'IndiaState' },
    city: { label: '', value: '' },
    pincode: '',
    customerName: data.partyName.label,
    gstin: data.gstin,

    errorStatus: {
      billingAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      customerName: false,
      city: false,
      gstin: false,
    },
    errorFields: {
      billingAddress: '',
      states: '',
      district: '',
      country: '',
      pincode: '',
      customerName: '',
      city: '',
      gstin: '',
    },
  });
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };
  const handleClear = () => {
    setState((prev) => ({
      ...prev,
      billingAddress: '',
      states: { label: '', value: 0, code: 0 },
      district: { label: '', value: '' },
      country: { label: 'India', value: 'IndiaState' },
      city: { label: '', value: '' },
      pincode: '',
      customerName: data?.partyName?.label ?? '',
      gstin: data?.gstin ?? '',
      errorStatus: {
        ...prev.errorStatus,
        billingAddress: false,
        states: false,
        district: false,
        country: false,
        pincode: false,
        customerName: false,
        city: false,
        gstin: false,
      },
      errorFields: {
        ...prev.errorFields,
        billingAddress: '',
        states: '',
        district: '',
        country: '',
        pincode: '',
        customerName: '',
        city: '',
        gstin: '',
      },
    }));
    setCityArr([]);
  };

  function formValidation(data) {
  let isValid = true;
  const obj = { ...state };

  // Reset previous errors
  Object.keys(obj.errorStatus).forEach((key) => {
    obj.errorStatus[key] = false;
    obj.errorFields[key] = '';
  });

  
  if(eImp || eWayImp){
  if (!data.billingAddress || data.billingAddress.trim() === '') {
    isValid = false;
    obj.errorStatus.billingAddress = true;
    obj.errorFields.billingAddress = 'Billing address is required';
  }

}
 if(eImp || eWayImp){
  if (!data.country?.value) {
    isValid = false;
    obj.errorStatus.country = true;
    obj.errorFields.country = 'Country is required';
  }
}
if(data?.country?.value==="IndiaState" || data?.country?.value===""){
  if(eImp || eWayImp){
  if (!data.states?.value) {
    isValid = false;
    obj.errorStatus.states = true;
    obj.errorFields.states = 'State is required';
  }
}

  if(eImp || eWayImp){
  if (!data.district?.value) {
    isValid = false;
    obj.errorStatus.district = true;
    obj.errorFields.district = 'District is required';
  }
  }
 

   if(eImp || eWayImp){
  if (!data.city?.value || data.city.label.trim() === '') {
    isValid = false;
    obj.errorStatus.city = true;
    obj.errorFields.city = 'City is required';
  }
   }
  if(eImp || eWayImp){
  if (!data.pincode || data.pincode.trim() === '') {
    isValid = false;
    obj.errorStatus.pincode = true;
    obj.errorFields.pincode = 'Pincode is required';
  } else if (!/^\d{6}$/.test(data.pincode.trim())) {
    isValid = false;
    obj.errorStatus.pincode = true;
    obj.errorFields.pincode = 'Invalid Postal / Zip Code';
  }
}
}


  setState(obj);
  return isValid;
}

  async function getCityArr(value) {
    try {
      const res = await LocationFetch(value); // waits for the fetch

      let cityArr = [];
      let citObj = { label: '', value: '' };
      if (res?.City) {
        res.City.map((ele) => {
          citObj = { label: ele, value: ele };
          cityArr.push(citObj);
        });

        setCityArr(cityArr);
      }
    } catch (error) {
      console.log('error', error);
      return null;
    }
  }

  // async function getAddressDetails() {
  //   try {
  //     const resPartyAddressEntityDetails = await API.graphql(
  //       graphqlOperation(getPartyAddressEntity, {
  //         objectid: partyID,
  //         objecttype: 'PartyBilling',
  //       })
  //     );
  //     let nameOfCountry = { label: '', value: '' };

  //     if (resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0] != null) {
  //       countryArr.map((ele) => {
  //         if (ele.value === resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].countrycode) {
  //           nameOfCountry = { label: ele?.label, value: ele?.value };
  //         }
  //       });
  //       let nameOfState = { label: '', value: '', code: '' };
  //       stateArr.map((ele) => {
  //         if (ele.code == resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].statecode)
  //           nameOfState = { label: ele.label, value: ele.value, code: ele?.code };
  //       });
  //       const city = {
  //         label: tempbillingAddressDetails?.city?.label?.trim()
  //           ? tempbillingAddressDetails.city.label
  //           : resPartyAddressEntityDetails?.data?.getPartyAddressEntity?.[0]?.city ?? '',
  //         value: tempbillingAddressDetails?.city?.label?.trim()
  //           ? tempbillingAddressDetails.city.label
  //           : resPartyAddressEntityDetails?.data?.getPartyAddressEntity?.[0]?.city ?? '',
  //       };

  //       setState((prev) => ({
  //         ...prev,
  //         billingAddress:
  //           tempbillingAddressDetails.billingAddress !== ''
  //             ? tempbillingAddressDetails.billingAddress
  //             : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].line1.replace('**', '\n'),
  //         country: tempbillingAddressDetails.country.value !== '' ? tempbillingAddressDetails.country : nameOfCountry,
  //         pincode:
  //           tempbillingAddressDetails.pincode !== ''
  //             ? tempbillingAddressDetails.pincode
  //             : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].pincode,
  //         city: city,
  //       }));
  //       getStatesModal(
  //         tempbillingAddressDetails.country.value !== ''
  //           ? tempbillingAddressDetails.country.value
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].countrycode,
  //         tempbillingAddressDetails.states.value !== ''
  //           ? tempbillingAddressDetails.states.value
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].statecode
  //       );

  //       getDistrictsModal(
  //         // resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].statecode,
  //         tempbillingAddressDetails.states.value !== '' ? tempbillingAddressDetails.states.value : nameOfState?.value,
  //         tempbillingAddressDetails.district.value !== ''
  //           ? tempbillingAddressDetails.district.value
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].district
  //       );
  //       getCityArr(
  //         tempbillingAddressDetails.pincode !== ''
  //           ? tempbillingAddressDetails.pincode
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].pincode
  //       );
  //     }
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // }
  async function getAddressDetails() {
    try {
      const resPartyAddressEntityDetails = await API.graphql(
        graphqlOperation(getPartyAddressEntity, {
          objectid: partyID,
          objecttype: 'PartyBilling',
        })
      );

      const partyAddr = resPartyAddressEntityDetails?.data?.getPartyAddressEntity?.[0];
      let nameOfCountry = { label: '', value: '' };
      let nameOfDistrict={label:'',value:''};

      if (partyAddr != null) {
        countryArr.map((ele) => {
          if (ele.value === partyAddr.countrycode) {
            nameOfCountry = { label: ele?.label, value: ele?.value };
          }
        });

        let nameOfState = { label: '', value: '', code: '' };
      
       
      

        const city = {
          label:
            tempbillingAddressDetails?.city?.label !== undefined && tempbillingAddressDetails?.city?.label !== null
              ? tempbillingAddressDetails.city.label
              : partyAddr?.city ?? '',
          value:
            tempbillingAddressDetails?.city?.label !== undefined && tempbillingAddressDetails?.city?.label !== null
              ? tempbillingAddressDetails.city.label
              : partyAddr?.city ?? '',
        };

        setState((prev) => ({
          ...prev,
          billingAddress:
            tempbillingAddressDetails?.billingAddress !== undefined && tempbillingAddressDetails?.billingAddress !== null
              ? tempbillingAddressDetails?.billingAddress
              : partyAddr?.line1,
          country:
            tempbillingAddressDetails?.country?.value !== undefined && tempbillingAddressDetails?.country?.value !== null
              ? tempbillingAddressDetails.country
              : nameOfCountry,
          pincode:
            tempbillingAddressDetails?.pincode !== undefined && tempbillingAddressDetails?.pincode !== null
              ? tempbillingAddressDetails.pincode
              : partyAddr?.pincode,
          city: city,
        }));
          if(partyAddr.countrycode==="IndiaState"){
             stateArr.map((ele) => {
          if (ele.code == partyAddr.statecode) {
            nameOfState = { label: ele.label, value: ele.value, code: ele?.code };
          }
        });
        getStatesModal(
          tempbillingAddressDetails?.country?.value !== undefined && tempbillingAddressDetails?.country?.value !== null
            ? tempbillingAddressDetails.country.value
            : partyAddr?.countrycode,
          tempbillingAddressDetails?.states?.value !== undefined && tempbillingAddressDetails?.states?.value !== null
            ? tempbillingAddressDetails.states.value
            : partyAddr?.statecode
        );
         getDistrictsModal(
          tempbillingAddressDetails?.states?.value !== undefined && tempbillingAddressDetails?.states?.value !== null
            ? tempbillingAddressDetails.states.value
            : nameOfState?.value,
          tempbillingAddressDetails?.district?.value !== undefined && tempbillingAddressDetails?.district?.value !== null
            ? tempbillingAddressDetails.district.value
            : partyAddr?.district
        );
      }else{
            
        nameOfState = { label:tempbillingAddressDetails?.states?.label !== undefined && tempbillingAddressDetails?.states?.label !== null? tempbillingAddressDetails?.states?.label:  partyAddr.foreignstate, value: 0, code: 0 };
        nameOfDistrict={label: tempbillingAddressDetails?.district?.label !== undefined && tempbillingAddressDetails?.district?.label !== null
            ? tempbillingAddressDetails.district.label
            : partyAddr?.foreigndistrict,value:tempbillingAddressDetails?.district?.label !== undefined && tempbillingAddressDetails?.district?.label !== null
            ? tempbillingAddressDetails.district.label
            : partyAddr?.foreigndistrict};
        setState((prev) => ({
          ...prev,
          states:nameOfState,
          district:nameOfDistrict
        }));
      
      }

       

        getCityArr(
          tempbillingAddressDetails?.pincode !== undefined && tempbillingAddressDetails?.pincode !== null
            ? tempbillingAddressDetails.pincode
            : partyAddr?.pincode
        );
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  // async function getAddressDetailsByInvId() {
  //   try {
  //     const resPartyAddressEntityDetails = await API.graphql(
  //       graphqlOperation(getPartyAddressEntity, {
  //         objectid: Type === 'Sales' ? invoiceEntry.invoiceid : Type === 'Purchase' ? invoiceEntry.purchaseid : invoiceEntry.crdrnoteid,
  //         objecttype: addressType,
  //       })
  //     );
  //     let nameOfCountry = { label: '', value: '' };
  //     if (resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0] != null) {
  //       countryArr.map((ele) => {
  //         if (ele.value === resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].countrycode) {
  //           nameOfCountry = { label: ele?.label, value: ele?.value };
  //         }
  //       });
  //       let nameOfState = { label: '', value: '' };
  //       stateArr.map((ele) => {
  //         if (ele.code == resPartyAddressEntityDetails.data.getPartyAddressEntity?.[0].statecode)
  //           nameOfState = { label: ele.label, value: ele.value, code: ele?.code };
  //       });
  //       const city = {
  //         label: tempbillingAddressDetails?.city?.label?.trim()
  //           ? tempbillingAddressDetails.city.label
  //           : resPartyAddressEntityDetails?.data?.getPartyAddressEntity?.[0]?.city ?? '',
  //         value: tempbillingAddressDetails?.city?.label?.trim()
  //           ? tempbillingAddressDetails.city.label
  //           : resPartyAddressEntityDetails?.data?.getPartyAddressEntity?.[0]?.city ?? '',
  //       };
  //       setState((prev) => ({
  //         ...prev,
  //         billingAddress:
  //           tempbillingAddressDetails.billingAddress !== ''
  //             ? tempbillingAddressDetails.billingAddress
  //             : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].line1.replace('**', '\n'),
  //         country: tempbillingAddressDetails.country.value !== '' ? tempbillingAddressDetails.country : nameOfCountry,
  //         pincode:
  //           tempbillingAddressDetails.pincode !== ''
  //             ? tempbillingAddressDetails.pincode
  //             : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].pincode,
  //         city: city,
  //       }));
  //       getStatesModal(
  //         tempbillingAddressDetails.country.value !== ''
  //           ? tempbillingAddressDetails.country.value
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].countrycode,
  //         tempbillingAddressDetails.states.value !== ''
  //           ? tempbillingAddressDetails.states.value
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].statecode
  //       );
  //       getDistrictsModal(
  //         // resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].statecode,
  //         tempbillingAddressDetails.states.value !== '' ? tempbillingAddressDetails.states.value : nameOfState?.value,
  //         tempbillingAddressDetails.district.value !== ''
  //           ? tempbillingAddressDetails.district.value
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].district
  //       );
  //       getCityArr(
  //         tempbillingAddressDetails.pincode !== ''
  //           ? tempbillingAddressDetails.pincode
  //           : resPartyAddressEntityDetails?.data.getPartyAddressEntity?.[0].pincode
  //       );
  //     }
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // }
  async function getAddressDetailsByInvId() {
    try {
      const resPartyAddressEntityDetails = await API.graphql(
        graphqlOperation(getPartyAddressEntity, {
          objectid: Type === 'Sales' ? invoiceEntry.invoiceid : Type === 'Purchase' ? invoiceEntry.purchaseid : invoiceEntry.crdrnoteid,
          objecttype: addressType,
        })
      );

      const partyAddr = resPartyAddressEntityDetails?.data?.getPartyAddressEntity?.[0];
      let nameOfCountry = { label: '', value: '' };
      let nameOfDistrict={ label: '', value: '' };

      if (partyAddr != null) {
        countryArr.map((ele) => {
          if (ele.value === partyAddr.countrycode) {
            nameOfCountry = { label: ele?.label, value: ele?.value };
          }
        });

        let nameOfState = { label: '', value: '', code: '' };
        stateArr.map((ele) => {
          if (ele.code == partyAddr.statecode) {
            nameOfState = { label: ele.label, value: ele.value, code: ele?.code };
          }
        });

        const city = {
          label:
            tempbillingAddressDetails?.city?.label !== undefined && tempbillingAddressDetails?.city?.label !== null
              ? tempbillingAddressDetails.city.label
              : partyAddr?.city ?? '',
          value:
            tempbillingAddressDetails?.city?.label !== undefined && tempbillingAddressDetails?.city?.label !== null
              ? tempbillingAddressDetails.city.label
              : partyAddr?.city ?? '',
        };

        setState((prev) => ({
          ...prev,
          billingAddress:
            tempbillingAddressDetails?.billingAddress !== undefined && tempbillingAddressDetails?.billingAddress !== null
              ? tempbillingAddressDetails.billingAddress
              : partyAddr?.line1,
          country:
            tempbillingAddressDetails?.country?.value !== undefined && tempbillingAddressDetails?.country?.value !== null
              ? tempbillingAddressDetails.country
              : nameOfCountry,
          pincode:
            tempbillingAddressDetails?.pincode !== undefined && tempbillingAddressDetails?.pincode !== null
              ? tempbillingAddressDetails.pincode
              : partyAddr?.pincode,
          city: city,
        }));
  if(partyAddr.countrycode==="IndiaState"){
        getStatesModal(
          tempbillingAddressDetails?.country?.value !== undefined && tempbillingAddressDetails?.country?.value !== null
            ? tempbillingAddressDetails.country.value
            : partyAddr?.countrycode,
          tempbillingAddressDetails?.states?.value !== undefined && tempbillingAddressDetails?.states?.value !== null
            ? tempbillingAddressDetails.states.value
            : partyAddr?.statecode
        );

        getDistrictsModal(
          tempbillingAddressDetails?.states?.value !== undefined && tempbillingAddressDetails?.states?.value !== null
            ? tempbillingAddressDetails.states.value
            : nameOfState?.value,
          tempbillingAddressDetails?.district?.value !== undefined && tempbillingAddressDetails?.district?.value !== null
            ? tempbillingAddressDetails.district.value
            : partyAddr?.district
        );
      }else{
         nameOfState = { label:tempbillingAddressDetails?.states?.label !== undefined && tempbillingAddressDetails?.states?.label !== null? tempbillingAddressDetails?.states?.label:  partyAddr.foreignstate, value: 0, code: 0 };
        nameOfDistrict={label: tempbillingAddressDetails?.district?.label !== undefined && tempbillingAddressDetails?.district?.label !== null
            ? tempbillingAddressDetails.district.label
            : partyAddr?.foreigndistrict,value:tempbillingAddressDetails?.district?.label !== undefined && tempbillingAddressDetails?.district?.label !== null
            ? tempbillingAddressDetails.district.label
            : partyAddr?.foreigndistrict};
        setState((prev) => ({
          ...prev,
          states:nameOfState,
          district:nameOfDistrict
        }));
      }

        getCityArr(
          tempbillingAddressDetails?.pincode !== undefined && tempbillingAddressDetails?.pincode !== null
            ? tempbillingAddressDetails.pincode
            : partyAddr?.pincode
        );
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  async function getStatesModal(code, state) {
    try {
      let nameOfstate = { label: '', value: '', code: '' };
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: code }));
      if (cities?.data?.getCodeTranslation != null) {
        let statesArray = (cities?.data?.getCodeTranslation).map((element) => {
          return {
            label: element.codetext,
            value: `${element.codetext}District`,
            code: element?.statecode,
          };
        });
        statesArray.map((ele) => {
          if (ele.code == state) {
            nameOfstate = { label: ele?.label, value: ele?.value, code: ele?.code };
          }
        });
        setState((prev) => ({
          ...prev,

          states: tempbillingAddressDetails.states.value !== '' ? tempbillingAddressDetails.states : nameOfstate,
        }));
        setStateArr(statesArray);
      }
    } catch (error) {}
  }
  async function getDistrictsModal(state, district) {
    try {
      let nameOfDistrict = { label: '', value: '' };
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: state }));

      let disArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          label: element.codetext,
          value: `${element.codetext}District`,
        };
      });
      disArray.map((ele) => {
        if (ele.value?.trim()?.toLowerCase() === district?.trim()?.toLowerCase()) {
          nameOfDistrict = { label: ele?.label, value: ele?.value };
        }
      });
      setState((prev) => ({
        ...prev,
        district: tempbillingAddressDetails.district.value !== '' ? tempbillingAddressDetails.district : nameOfDistrict,
      }));
      setDistrictArr(disArray);
    } catch (error) {}
  }
  async function getCountries() {
    let code = 'Country';
    const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: code }));

    if (cities?.data?.getCodeTranslation != null) {
      let countriesArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          label: element.codetext,
          value: `${element.codetext}State`,
        };
      });
      setCountryArr(countriesArray);
    }
  }
  useEffect(() => {
    getCountries();
  }, []);
  useEffect(() => {
    if (editFlag == false) {
      if (invoiceEntry.length == 0) {
        getAddressDetails();
      } else {
        getAddressDetailsByInvId();
      }
    }
  }, [editFlag]);

  async function saveChanges() {
    const { billingAddress, country, states, district, pincode, city } = state;
    const formData = {
      billingAddress,
      country,
      states,
      district,
      pincode,
      city,
    };

    let nameOfstate = { label: '', value: 0, code: 0 };
    let nameOfDistrict = { label: '', value: '' };
    let nameOfCountry = { label: '', value: '' };
  

    countryArr.map((ele) => {
      if (ele.value === country.value) {
        nameOfCountry = { label: ele?.label, value: ele?.value };
      }
    });
   if(country?.value==='IndiaState'){
    districtArr.map((ele) => {
      if (ele?.value?.trim()?.toLowerCase() === district?.value?.trim()?.toLowerCase()) {
        nameOfDistrict = { label: ele.label, value: ele.value };
      }
    });
      stateArr.map((ele) => {
      if (ele.code === states.code) {
        nameOfstate = { label: ele?.label, value: ele?.value, code: ele?.code };
      }
    });
  }else{
    nameOfstate = { label: states?.label, value: 0, code: 0 };
      nameOfDistrict = { label: district?.label, value: district.value };
  }

    if (formValidation(formData)) {
      setState((prev) => ({
        ...prev,
        billingAddress: billingAddress,
        country: country,
        district: district,
        states: states,
        pincode: pincode,
        city: city,
        stateCD: nameOfstate,
        districtCD: nameOfDistrict,
        cityCD: city,
      }));
      setTempBillingAddressDetails((prev) => ({
        ...prev,
        billingAddress: billingAddress,
        country: nameOfCountry,
        district: nameOfDistrict,
        states: nameOfstate,
        pincode: pincode,
        stateCD: nameOfstate,
        city: city,
        cityCD: city,
        districtCD: nameOfDistrict,
      }));
      setBillingAddressDetails((prev) => ({
        ...prev,
        billingAddress: billingAddress,
        country: nameOfCountry.value,
        district: nameOfDistrict.value,
        states: nameOfstate?.code ?? 0,
        stateCD: nameOfstate,
        pincode: pincode,
        districtCD: nameOfDistrict,
        countryCD: nameOfCountry,
        city: city,
        cityCD: city,
      }));
      setEditFlag(true);
      if (checkPermanent === true) {
        saveBillingAddressPermanently();
      }
      setOpen(false);
    }
  }
  async function GSTStatesModal(code, state) {
    try {
      let nameOfstate = { label: '', value: '', code: '' };
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: code }));
      if (cities?.data?.getCodeTranslation != null) {
        let statesArray = (cities?.data?.getCodeTranslation).map((element) => {
          return {
            label: element.codetext,
            value: `${element.codetext}District`,
            code: element?.statecode,
          };
        });
        statesArray.map((ele) => {
          if (ele.value?.trim()?.toLowerCase() === state?.trim()?.toLowerCase()) {
            nameOfstate = {
              label: ele.label,
              value: ele.value,
              code: ele?.code,
            };
          }
        });
        setState((prev) => ({
          ...prev,
          states: nameOfstate,
        }));
        setStateArr(statesArray);
      }
    } catch (error) {}
  }
  async function GSTDistrictsModal(state, district) {
    try {
      let nameOfDistrict = { label: '', value: '' };
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: state }));

      let disArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          label: element.codetext,
          value: `${element.codetext}District`,
        };
      });
      disArray.map((ele) => {
        if (ele.value?.trim()?.toLowerCase() === district?.trim()?.toLowerCase()) {
          nameOfDistrict = { label: ele.label, value: ele.value };
        }
      });
      setState((prev) => ({
        ...prev,
        district: nameOfDistrict,
      }));
      setDistrictArr(disArray);
    } catch (error) {}
  }
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      customerName: data.partyName.label,
      gstin: data.gstin,
    }));
  }, [open]);
  async function saveBillingAddressPermanently() {
    try {
      let billAdd = state?.billingAddress ? state?.billingAddress : '';
      const billaddressDetails = {
        consigneename: String(state.customerName),
        consigneegstin: String(state.gstin),

        countrycode: state?.country?.value ?? '',

        // line1: billAdd.length > 0 ? billAdd.join('**') : '',
        line1: billAdd.length > 0 ? billAdd : '',
        line2: '',
        line3: '',
        objectid: data?.partyName?.value,
        objecttype: 'PartyBilling',

        pincode: state?.pincode ?? '',

        statecode: state?.states?.code ?? 0,

        district: state?.district?.value ?? '',

        expiredtimestamp: 0,
        financialyearid: userPreferece?.financialYear?.financialyearid,
        city: state?.city?.value ?? '',
        foreignstate:state?.states?.label??'',
        foreigndistrict:state?.district?.label??''
      };
      const resPartyBillingAddressEntity = await API.graphql(
        graphqlOperation(createPartyAddressEntity, {
          createPartyAddressEntityInput: [billaddressDetails],
        })
      );
      if (resPartyBillingAddressEntity?.data?.createPartyAddressEntity) {
        setIsChanged(false);
        setCheckPermanent(false);
        const role = partyType === 'CUSTOMER' ? 'customer' : 'supplier';
        showSuccessSnackbar(`The billing address has been saved permanently for the ${role}.`);
      }
    } catch (error) {
      console.log('error', error);
    }
  }
function handleAddressChange(e) {
  const { name, value } = e.target;

  setIsChanged(value !== state[name]);

  let errorMessage = '';
  let hasError = false;

  switch (name) {
    case 'billingAddress':
      if (value.trim() === '') {
        errorMessage = 'Billing Address is required';
        hasError = true;
      }
      break;

    case 'pincode':
      if (!/^\d{6}$/.test(value.trim())) {
        errorMessage = 'Invalid Postal / Zip Code';
        hasError = true;
      }
      break;

    case 'customerName':
      if (value.trim() === '') {
        errorMessage = 'Customer name is required';
        hasError = true;
      }
      break;

    case 'gstin':
      if (value && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value.trim())) {
        errorMessage = 'Invalid GSTIN format';
        hasError = true;
      }
      break;

    default:
      break;
  }

  setState((prev) => ({
    ...prev,
    [name]: value,
    errorStatus: {
      ...prev.errorStatus,
      [name]: hasError,
    },
    errorFields: {
      ...prev.errorFields,
      [name]: errorMessage,
    },
  }));
}
const handlePincodeChange = async (e) => {
  const { value } = e.target;
  let nameOfState = { label: '', value: '', code: '' };

  setIsChanged(value !== state?.pincode);

  // Empty → reset
  if (value === '') {
    setState((prev) => ({
      ...prev,
      pincode: value,
      states: { label: '', value: '', code: '' },
      district: { label: '', value: '' },
      city: { label: '', value: '' },
      errorStatus: { ...prev.errorStatus, pincode: true },
      errorFields: { ...prev.errorFields, pincode: 'Pincode is required' },
    }));
    return;
  }

  // Invalid pincode
  if (!/^\d{6}$/.test(value)) {
    setState((prev) => ({
      ...prev,
      pincode: value,
      errorStatus: { ...prev.errorStatus, pincode: true },
      errorFields: { ...prev.errorFields, pincode: 'Invalid Postal / Zip Code' },
    }));
    return;
  }

  // Valid pincode → clear error & fetch location
  setState((prev) => ({
    ...prev,
    pincode: value,
    errorStatus: { ...prev.errorStatus, pincode: false },
    errorFields: { ...prev.errorFields, pincode: '' },
  }));

  try {
    const res = await LocationFetch(value);

    await getStates('IndiaState');
    await getDistricts(res.State + 'District');
    GSTStatesModal('IndiaState', `${res?.State}District`);
    GSTDistrictsModal(`${res?.State}District`, `${res?.District}District`);

    const cityArr = res?.City?.map((ele) => ({ label: ele, value: ele })) || [];
    setCityArr(cityArr);

    stateArr.forEach((ele) => {
      if (ele?.label?.toLowerCase() === res?.State?.toLowerCase()) {
        nameOfState = { label: ele.label, value: ele.value, code: ele.code };
      }
    });

    setState((prev) => ({
      ...prev,
      country: { label: 'India', value: 'IndiaState' },
      states: nameOfState,
      district: { label: res.District, value: `${res.District}District` },
      city: cityArr?.length ? { label: cityArr?.[0]?.label??"", value: cityArr?.[0]?.value??"" } : { label: '', value: '' },
      errorStatus: {
        ...prev.errorStatus,
        pincode: false,
        states: false,
        district: false,
        country: false,
      },
      errorFields: {
        ...prev.errorFields,
        pincode: '',
        states: '',
        district: '',
        country: '',
      },
    }));
  } catch (err) {
    console.error('Location fetch error:', err);
    setState((prev) => ({
      ...prev,
      errorStatus: { ...prev.errorStatus, pincode: true },
      errorFields: { ...prev.errorFields, pincode: 'Unable to fetch location data' },
    }));
  }
};
const handleCountryChange = (e, newValue) => {
  // Case 1 — User cleared the value
  if (!newValue) {
    setState((prev) => ({
      ...prev,
      country: { label: '', value: '' },
      states: { label: '', value: '', code: '' },
      district: { label: '', value: '' },
      city: { label: '', value: '' },
      errorStatus: { ...prev.errorStatus, country: true },
      errorFields: { ...prev.errorFields, country: 'Country is required' },
    }));
    setIsChanged(true);
    return;
  }

  // Case 2 — If selected country is same as previous → no change
  if (newValue?.value === state?.country?.value) {
    setIsChanged(false);
  } else {
    setIsChanged(true);
  }

  // Case 3 — Valid selection → fetch dependent data
  getStates(newValue.value);

  setState((prev) => ({
    ...prev,
    country: newValue,
    // Reset dependent fields only if the country actually changed
    states:
      newValue?.value !== prev?.country?.value ? { label: '', value: '', code: '' } : prev?.states,
    district:
      newValue?.value !== prev?.country?.value ? { label: '', value: '' } : prev?.district,
    city:
      newValue?.value !== prev?.country?.value ? { label: '', value: '' } : prev?.city,
    errorStatus: { ...prev.errorStatus, country: false },
    errorFields: { ...prev.errorFields, country: '' },
  }));
};
const handleStateChange = (e, newValue) => {
  // Case A — Autocomplete (IndiaState)
  if (newValue !== undefined) {
    // Cleared selection
    if (!newValue) {
      setState((prev) => ({
        ...prev,
        states: { label: '', value: '', code: '' },
        district: { label: '', value: '' },
        city: { label: '', value: '' },
        errorStatus: { ...prev.errorStatus, states: true },
        errorFields: { ...prev.errorFields, states: 'State is required' },
      }));
      setIsChanged(true);
      return;
    }

    // Same selection → no change
    if (newValue?.value === state?.states?.value) {
      setIsChanged(false);
    } else {
      setIsChanged(true);
    }

    // Fetch dependent data
    getDistrictsModal(newValue?.value);

    setState((prev) => ({
      ...prev,
      states: newValue,
      district:
        newValue?.value !== prev?.states?.value ? { label: '', value: '' } : prev?.district,
      city:
        newValue?.value !== prev?.states?.value ? { label: '', value: '' } : prev?.city,
      errorStatus: { ...prev.errorStatus, states: false },
      errorFields: { ...prev.errorFields, states: '' },
    }));

    return;
  }

  // Case B — Manual input (non-India countries)
  const value = e.target.value;

  setIsChanged(value !== state?.states?.label);

  let hasError = false;
  let errorMessage = '';

  if (value.trim() === '') {
    hasError = true;
    errorMessage = 'State is required';
  }

  setState((prev) => ({
    ...prev,
    states: { label: value, value: 0, code: 0 },
    errorStatus: { ...prev.errorStatus, states: hasError },
    errorFields: { ...prev.errorFields, states: errorMessage },
  }));
};
const handleDistrictChange = (e, newValue) => {
  // Case A — Autocomplete (India)
  if (newValue !== undefined) {
    // Cleared value
    if (!newValue) {
      setState((prev) => ({
        ...prev,
        district: { label: '', value: '' },
        city: { label: '', value: '' },
        errorStatus: { ...prev.errorStatus, district: true },
        errorFields: { ...prev.errorFields, district: 'District is required' },
      }));
      setIsChanged(true);
      return;
    }

    // Detect if changed
    setIsChanged(newValue?.value !== state?.district?.value);

    // Update district
    setState((prev) => ({
      ...prev,
      district: newValue,
      city:
        newValue?.value !== prev?.district?.value ? { label: '', value: '' } : prev?.city,
      errorStatus: { ...prev.errorStatus, district: false },
      errorFields: { ...prev.errorFields, district: '' },
    }));

    return;
  }

  // Case B — Manual input (Non-India)
  const value = e.target.value;

  setIsChanged(value !== state?.district?.label);

  let hasError = false;
  let errorMessage = '';

  if (value.trim() === '') {
    hasError = true;
    errorMessage = 'District is required';
  }

  setState((prev) => ({
    ...prev,
    district: { label: value, value },
    errorStatus: { ...prev.errorStatus, district: hasError },
    errorFields: { ...prev.errorFields, district: errorMessage },
  }));
};

const handleCityChange = (e, newValue, reason) => {
  // When selecting from dropdown list
  if (reason === "selectOption") {
    setIsChanged(newValue?.label !== state?.city?.label);

    setState((prev) => ({
      ...prev,
      city: {
        label: newValue?.label,
        value: newValue?.value,
      },
      errorStatus: { ...prev.errorStatus, city: false },
      errorFields: { ...prev.errorFields, city: "" },
    }));
    return;
  }

  // When typing manually (freeSolo)
  if (reason === "input") {
    if (typeof newValue === "string") {
      setState((prev) => ({
        ...prev,
        city: { label: newValue, value: newValue },
      }));
    }
  }
};



  useSaveModalShortcut(saveChanges);
  return (
    <Box id={open ? 'BillingAddressModal' : ''}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Paper sx={style}>
            <Box
              sx={{
                backgroundColor: 'primary.main',
                padding: '5px 15px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  Edit Billing Address
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: '#fff' }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                padding: '15px',
                height: { xs: '400px', sm: 'auto' },
                overflowY: { xs: 'scroll', sm: 'hidden' },
                minWidth: { xs: '200px' ,sm:'400px'},
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'column' },
                  flexWrap: { xs: 'wrap', md: 'nowrap' },
                }}
              >
                {registrationType !== 1 ? (
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1, display: 'flex',flexDirection:{xs:'column',sm:'row'}, }}>
                    <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                      <TextField
                        name="gstin"
                        placeholder="GSTIN"
                        label="GSTIN"
                        size="small"
                        disabled={true}
                        value={state.gstin}
                        onChange={(e) => {
                          const name = e.target.name;
                          const value = e.target.value;

                          if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Za-z]{1}$/.test(value) && value !== '') {
                            setState((prev) => ({
                              ...prev,
                              gstin: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                gstin: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                gstin: 'Invalid GSTIN',
                              },
                            }));
                          } else {
                            if (value === state?.gstin) {
                              setIsChanged(false);
                            } else {
                              setIsChanged(true);
                            }
                            setData((prev) => ({
                              ...prev,
                              consigneeGST: value,
                            }));
                            setState((prev) => ({
                              ...prev,
                              gstin: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                gstin: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                gstin: '',
                              },
                            }));
                          }
                        }}
                        sx={{
                          '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                            fontSize: '14px',
                          },
                          label: {
                            fontSize: '14px',
                          },
                          width:"100%"
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                      <TextField
                        name="customerName"
                        placeholder="Customer Name"
                        label="Customer Name"
                        size="small"
                        value={state.customerName}
                        disabled={true}
                        sx={{
                          '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                            fontSize: '14px',
                          },
                          label: {
                            fontSize: '14px',
                          },
                          width:"100%"
                        }}
                        onChange={(e) => {
                          const name = e.target.name;
                          const value = e.target.value;
                          if (value === '') {
                            setState((prev) => ({
                              ...prev,
                              customerName: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                customerName: true,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                customerName: 'Consignee Name is required',
                              },
                            }));
                          } else {
                            if (value === state?.customerName) {
                              setIsChanged(false);
                            } else {
                              setIsChanged(true);
                            }
                            setState((prev) => ({
                              ...prev,
                              customerName: value,
                              errorStatus: {
                                ...prev.errorStatus,
                                customerName: false,
                              },
                              errorFields: {
                                ...prev.errorFields,
                                customerName: '',
                              },
                            }));
                            setData((prev) => ({
                              ...prev,
                              consigneeName: value,
                            }));
                          }
                        }}
                      />
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    <TextField
                      name="customerName"
                      placeholder="Customer Name"
                      label="Customer Name"
                      size="small"
                      fullWidth
                      value={state.customerName}
                      inputProps={{ readOnly: true }}
                      sx={{
                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                          fontSize: '14px',
                        },
                        label: {
                          fontSize: '14px',
                        },
                      }}
                    />
                  </Box>
                )}
                <Box sx={{ flex: { xs: 1, md: 1 }, mt: 1, mb: 1, m: 2 }}>
                  <TextField
                    error={state.errorStatus.billingAddress == true ? true : false}
                    name="billingAddress"
                    label="Address Details"
                    multiline
                    variant="outlined"
                    size="small"
                    fullWidth
                    required={eWayImp || eImp}
                    type="text"
                    value={state.billingAddress}
                    rows={4}
                    // required={state.billingAddress === "" ? true : false}
                    sx={{
                      '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                        fontSize: '14px',
                      },
                      label: {
                        fontSize: '14px',
                      },
                      '.css-wgai2y-MuiFormLabel-asterisk': {
                        color: 'danger.main',
                      },
                    }}
                     onChange={handleAddressChange}
                    InputProps={{
                      classes: {
                        input: 'custom-scrollbar', // Your custom class
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {state.errorFields.billingAddress}
                  </Typography>
                </Box>
                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1, display: 'flex',flexDirection:{xs:'column', sm:'row'} }}>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    <TextField
                      error={state.errorStatus.pincode == true ? true : false}
                      name="pincode"
                      label="Postal / Zip Code"
                      variant="outlined"
                      size="small"
                      fullWidth
                       required={(eWayImp || eImp) && (state?.country?.value==="IndiaState" ||state?.country?.value==="")}
                      type="text"
                      value={state.pincode}
                      sx={{
                        '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                          fontSize: '14px',
                        },
                        label: {
                          fontSize: '14px',
                        },
                      }}
                    onChange={handlePincodeChange}
                    />
                    <Typography
                      sx={{
                        marginTop: '2px',
                        marginLeft: '10px',
                        marginBottom: '0px',
                        fontSize: '11px',
                        color: 'danger.main',
                      }}
                    >
                      {state.errorFields.pincode}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    <Autocomplete
                      name="country"
                      size="small"
                      fullWidth
                      isOptionEqualToValue={(option, value) => option.value === value?.value}
                      disablePortal
                      clearOnEs
                      disableClearable={!state.country?.value}
                      value={state.country}
                      options={countryArr}
                      onChange={handleCountryChange}
                      renderInput={(params) => (
                        <TextField
                          // required={state?.country?.value === "" ? true : false}
                          error={state?.errorStatus?.country === true ? true : false}
                          required={(eWayImp || eImp)}
                          sx={{
                            '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                              padding: '8.5px 7px',
                            },
                            '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                              fontSize: '14px',
                            },
                            label: {
                              fontSize: '14px',
                            },
                            '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                              fontSize: '14px',
                            },
                            '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                              color: 'input.font',
                            },
                            '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                              borderColor: 'input.border',
                            },
                            '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                              color: 'input.font',
                            },
                            '.css-14qz1ij-MuiListItemText-root': {
                              margin: '0px',
                            },
                            '.css-wgai2y-MuiFormLabel-asterisk': {
                              color: 'danger.main',
                              fontWeight: 'bold',
                              fontSize: '16px',
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          {...params}
                          label="Country"
                        />
                      )}
                    />
                     <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {state.errorFields.country}
                  </Typography>
                  </Box>
                </Box>
                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1, display: 'flex',flexDirection:{xs:'column', sm:'row'} }}>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    {state?.country?.value === 'IndiaState' ? (
                      <Autocomplete
                        name="states"
                        open={openState}
                        placeholder="State/Province"
                        size="small"
                        value={state.states}
                     
                        disableClearable={!state.states?.value}
                        options={stateArr}
                        onChange={handleStateChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            onFocus={() => setOpenState(true)}
                            required={(eWayImp || eImp) && (state?.country?.value==="IndiaState" ||state?.country?.value==="")}
                            onBlur={() => setOpenState(false)}
                            error={state?.errorStatus?.states}
                            label="State/Province"
                            sx={{
                              '.MuiInputBase-input': { padding: '8.5px 7px' },
                              fontSize: '14px',
                              '.MuiFormLabel-asterisk': {
                                color: 'danger.main',
                                fontWeight: 'bold',
                                fontSize: '16px',
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        name="states"
                        label="State/Province"
                         error={state?.errorStatus?.states}
                        value={state?.states?.label || ''}
                        required={(eWayImp || eImp) && (state?.country?.value==="IndiaState" ||state?.country?.value==="")}
                       onChange={handleStateChange}
                        sx={{
                          '.MuiInputBase-input': { padding: '8.5px 7px' },
                          fontSize: '14px',
                          '.MuiFormLabel-asterisk': {
                            color: 'danger.main',
                            fontWeight: 'bold',
                            fontSize: '16px',
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                     <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {state.errorFields.states}
                  </Typography>
                  </Box>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    {state?.country?.value === 'IndiaState' ? (
                      <Autocomplete
                        name="district"
                        size="small"
                        value={state.district}
                        disableClearable={!state?.district?.value}
                        options={districtArr}
                        onChange={handleDistrictChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={state?.errorStatus?.district}
                              required={(eWayImp || eImp) && (state?.country?.value==="IndiaState" ||state?.country?.value==="")}
                            label="District"
                            sx={{
                              '.MuiInputBase-input': { padding: '8.5px 7px' },
                              fontSize: '14px',
                              '.MuiFormLabel-asterisk': {
                                color: 'danger.main',
                                fontWeight: 'bold',
                                fontSize: '16px',
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        name="district"
                        label="District"
                         error={state?.errorStatus?.district}
                        value={state?.district?.label || ''}
                        required={(eWayImp || eImp) && (state?.country?.value==="IndiaState" ||state?.country?.value==="")}
                        onChange={handleDistrictChange
                         
                        }
                        sx={{
                          '.MuiInputBase-input': { padding: '8.5px 7px' },
                          fontSize: '14px',
                          '.MuiFormLabel-asterisk': {
                            color: 'danger.main',
                            fontWeight: 'bold',
                            fontSize: '16px',
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                     <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {state.errorFields.district}
                  </Typography>
                  </Box>
                </Box>
                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1, display: 'flex' }}>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    {/* {state?.country?.value === 'IndiaState' ? (
                      <Autocomplete
                        name="city"
                        placeholder="City"
                        size="small"
                        value={state.city}
                        disableClearable={!state?.city?.value}
                        options={cityArr}
                        onChange={(e, newValue) => {
                          if (!newValue) {
                            setState((prev) => ({
                              ...prev,
                              city: { label: '', value: '' },
                              errorStatus: { ...prev.errorStatus, city: false },
                              errorFields: { ...prev.errorFields, city: '' },
                            }));
                            return;
                          }

                          setIsChanged(newValue !== state?.city);
                          setState((prev) => ({
                            ...prev,
                            city: newValue,
                            errorStatus: { ...prev.errorStatus, city: false },
                            errorFields: { ...prev.errorFields, city: '' },
                          }));
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={state?.errorStatus?.city}
                            label="City"
                            sx={{
                              '.MuiInputBase-input': { padding: '8.5px 7px' },
                              fontSize: '14px',
                              '.MuiFormLabel-asterisk': {
                                color: 'danger.main',
                                fontWeight: 'bold',
                                fontSize: '16px',
                              },
                            }}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                              autoCorrect: 'off',
                              spellCheck: 'false',
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                      />
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        name="city"
                        label="City"
                        
                        value={state?.city?.label || ''}
                        onChange={(e) =>
                          setState((prev) => ({
                            ...prev,
                            city: { label: e.target.value, value: e.target.value },
                            errorStatus: { ...prev.errorStatus, city: false },
                            errorFields: { ...prev.errorFields, city: '' },
                          }))
                        }
                        sx={{
                          '.MuiInputBase-input': { padding: '8.5px 7px' },
                          fontSize: '14px',
                          '.MuiFormLabel-asterisk': {
                            color: 'danger.main',
                            fontWeight: 'bold',
                            fontSize: '16px',
                          },
                        }}
                        inputProps={{
                          autoComplete: 'off',
                          autoCorrect: 'off',
                          spellCheck: 'false',
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )} */}
<Autocomplete
  name="city"
  size="small"
  freeSolo
  value={state.city || null}
  options={cityArr || []}

  // ✅ Display text correctly for both object & string
  getOptionLabel={(option) =>
    typeof option === "string" ? option : option?.label || ""
  }

  // ✅ Proper comparison to avoid [object Object]
  isOptionEqualToValue={(option, value) => option?.value === value?.value}

  onChange={handleCityChange}
  onInputChange={handleCityChange}

  renderInput={(params) => (
    <TextField
      {...params}
      label="City"
      InputLabelProps={{ shrink: true }}
      error={state?.errorStatus?.city}
      required={
        (eWayImp || eImp) &&
        (state?.country?.value === "IndiaState" ||
          state?.country?.value === "")
      }
      sx={{
        ".MuiInputBase-input": { padding: "8.5px 7px" },
        fontSize: "14px",
        ".MuiFormLabel-asterisk": {
          color: "danger.main",
          fontWeight: "bold",
          fontSize: "16px",
        },
      }}
      inputProps={{
        ...params.inputProps,
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: "false",
      }}
    />
  )}
/>
 <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {state.errorFields.city}
                  </Typography>

                  </Box>
                </Box>
              </Box>
              {/* {isChanges === true && ( */}
              <FormControlLabel
                sx={{
                  margin: 1, // remove extra gap from label
                  gap: '5px',
                  '& .MuiFormControlLabel-label': {
                    color: 'primary.main',
                    // fontWeight: 'bold',
                    fontSize: '14px',
                  },
                  '& .MuiCheckbox-root': {
                    padding: 0, // shrink spacing
                    color: '#6096d9',
                    '&.Mui-checked': {
                      color: '#6096d9',
                    },
                  },
                }}
                control={
                  <Checkbox
                    size="small"
                    sx={{
                      '& .MuiSvgIcon-root': { fontSize: 16 }, // tick size
                    }}
                    checked={checkPermanent}
                    onChange={(e) => {
                      setCheckPermanent(e.target.checked);
                    }}
                  />
                }
                label={"Set this as default billing address"
                  // partyType === 'CUSTOMER'
                  //   ? 'Save the billing address permanently for the customer'
                  //   : 'Save the billing address permanently for the supplier'
                }
              />
              {/* // )} */}
              
            </Box>
            
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row' },
              }}
            >
              <Button onClick={handleClear} variant="outlined" sx={{ flex: 1, margin: '10px', fontSize: '12px' }}>
                Clear
              </Button>
              <Button onClick={handleClose} variant="outlined" sx={{ flex: 1, margin: '10px', fontSize: '12px' }}>
                Cancel
              </Button>
              <Button onClick={saveChanges} variant="contained" sx={{ flex: 1, margin: '10px', fontSize: '12px' }}>
                Save
              </Button>
            </Box>
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
};

export default EditBillingAddressModal;
